export const shortAddress = (account?: string | null) => {
  if (!account) return "";
  return `${account.slice(0, 6)}...${account.slice(-4)}`;
};

export const toDisplayMessage = (value: unknown): string | null => {
  if (!value) return null;
  if (typeof value === "string") return value;
  if (typeof value === "object") {
    const record = value as Record<string, unknown>;
    if (typeof record.message === "string") return record.message;
    if (typeof record.error === "string") return record.error;
    if (record.error) return toDisplayMessage(record.error);
  }
  return null;
};
